import Vue from 'vue';
import Antd, { message } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
// import ElementUI from './utils/element-components';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import App from './App.vue';
import store from './store';
import { isMac } from './utils';
import uploader from './utils/uploadInput';
import { detectFont } from './series/seriesUtils';
import VueCompositionApi from '@vue/composition-api'
Vue.config.productionTip = false;

Vue.use(Antd);
Vue.use(ElementUI);
Vue.use(VueCompositionApi);
async function notifyDetectFont(font, efid) {
  const key = 'detectFont' + font;
  const { fontStates, fontNameLookup } = store.state;
  let timer, loading;

  try {
    if (fontStates[font]) {
      if (fontStates[font] === 'error') {
        throw new Error('font loading error');
      }
      return;
    }
    timer = setTimeout(() => {
      timer = null;
      if (store.state.selectedEffectIds.some(id => id === efid)) {
        loading = true;
        store.commit('handleLoading', true);
      }
    }, 300);
    await detectFont(font, fontNameLookup);
    fontStates[font] = 'done';
  } catch (e) {
    fontStates[font] = 'error';
    message.error({
      content: '字体加载错误: ' + font,
      key,
      duration: 2
    });
  }
  if (timer) {
    clearTimeout(timer);
  } else if (loading) {
    store.commit('handleLoading', false);
  }
}

Vue.directive('report-hover', (() => {
  const wm = new WeakMap();

  /**
   * @param {MouseEvent} e
   */
  const processHover = (e) => {
    const effectId = wm.get(e.target);
    if (effectId) {
      store.commit('handleEffectHover', effectId);
    }
  };

  const processMouseDown = (e) => {
    const effectId = wm.get(e.currentTarget);
    const { state } = store;
    if (effectId && !e.button && !state.playing) {
      if (isMac ? e.metaKey : e.ctrlKey) {
        store.dispatch('selectMultipleEffects', state.selectedEffectIds.concat(effectId));
      } else {
        console.log(effectId);
        store.commit('handleEffectSelect', [effectId]);
      }
      store.commit('handleEffectDrag', {
        clientX: e.clientX,
        clientY: e.clientY,
        effectId
      });
    }
  };

  const processContextMenu = (e) => {
    const effectId = wm.get(e.currentTarget);
    if (effectId) {
      e.preventDefault();
      store.commit('handleEffectSelect', [effectId]);
      store.dispatch('openEffectContextMenu', {
        x: e.clientX,
        y: e.clientY,
        effectId,
        cover: true
      });
    }
  };

  const processLeave = (e) => {
    const effectId = wm.get(e.currentTarget);
    if (effectId) {
      store.commit('handleEffectHover', null);
    }
  };

  return {
    /**
     * @param{HTMLElement} el test
     */
    bind(el, binding, vn) {
      el.addEventListener('mouseenter', processHover);
      el.addEventListener('mouseleave', processLeave);

      el.addEventListener('mousedown', processMouseDown);
      el.addEventListener('contextmenu', processContextMenu);

      wm.set(el, binding.value);
      if (binding.value) {
        const vm = vn.componentInstance;
        if (vm && vm.effect && /^text/.test(vm.effect.type)) {
          notifyDetectFont(vm.effect.content.fontFamily, binding.value);
          vm.$watch('effect.content.fontFamily', function (font) {
            notifyDetectFont(font, binding.value);
          });
        }
      }
    },
    update(el, binding) {
      wm.set(el, binding.value);
    },
    unbind(el) {
      el.removeEventListener('mouseenter', processHover);
      el.removeEventListener('mouseleave', processLeave);
      el.removeEventListener('mousedown', processMouseDown);
      el.removeEventListener('contextmenu', processContextMenu);
    }
  }
})());

uploader.addEventListener('change', (e) => {
  store.dispatch('uploadToOSS', e);
});

const lock = () => {
  window.onbeforeunload = () => 'Are you sure?';
  window.removeEventListener('mousedown', lock, true);
};

window.addEventListener('mousedown', lock, true);

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
